import ArchPropertiesPane from '../_ARCH/ArchPropertiesPane.jsx'

export default function PropertiesPaneOa(props) {
    return (
        <ArchPropertiesPane
            {...props}
        />
    )
}
